import { Pagination } from '@shared/ui';

interface ReconciliationTablePaginationProps {
  pagination: { page: number; limit: number; total: number };
  onPageChange: (page: number) => void;
  className?: string;
}

export function ReconciliationTablePagination({
  pagination,
  onPageChange,
  className,
}: ReconciliationTablePaginationProps) {
  return (
    <Pagination
      className={className}
      page={pagination.page}
      limit={pagination.limit}
      total={pagination.total}
      onPageChange={onPageChange}
    />
  );
}
